import { render, staticRenderFns } from "./ProductLandingPage.vue?vue&type=template&id=5fad8559&"
import script from "./ProductLandingPage.vue?vue&type=script&lang=js&"
export * from "./ProductLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductLandingPage.vue?vue&type=style&index=0&id=5fad8559&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports